export default function IconOrbit({ icons, labels, labelClass = "text-red-700", className = "", testId }) {
  const n = icons.length;
  return (
    <div data-testid={testId} aria-hidden="true" className={className}>
      <div className="attitudes-bg-spin absolute inset-0">
        {icons.map((src, k) => {
          const ang = ((-90 + k * (360 / n)) * Math.PI) / 180;
          const left = 50 + 33.33 * Math.cos(ang);
          const top = 50 + 33.33 * Math.sin(ang);
          const label = labels?.[k];
          return (
            <div
              key={src}
              className="attitudes-icon-stay absolute flex flex-col items-center"
              style={{
                left: `${left}%`,
                top: `${top}%`,
                width: label ? "46%" : "39.17%",
              }}
            >
              <img src={src} alt="" loading="lazy" style={{ width: label ? "85%" : "100%" }} />
              {label && (
                <span
                  data-testid={`${testId}-label-${k}`}
                  className={`text-center font-semibold leading-tight ${labelClass}`}
                  style={{
                    fontSize: "clamp(8px, 2vw, 12px)",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    borderRadius: "6px",
                    padding: "1px 5px",
                    marginTop: "-4%",
                    zIndex: 2,
                  }}
                >
                  {label}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
